import { useMemo } from "react";
import { useGetCountriesQuery } from "~/graphql/supergraphHooks";
import { capitalizeEachWord } from "~/utils/strings";

export type CountryOption = { code: string; name: string; id: number };

export const useCountryOptions = (): { loading: boolean; countryOptions: CountryOption[] } => {
  const { loading, data } = useGetCountriesQuery();

  const countryOptions = useMemo(
    () =>
      data?.complianceCountries
        ?.filter((c) => !!c?.alpha2code)
        ?.map((c) => ({ code: c.alpha2code ?? "", name: capitalizeEachWord(c.name), id: c.id }))
        ?.sort((a, b) => (a.name < b.name ? -1 : 1)) ?? [],
    [data],
  );

  return { loading, countryOptions };
};
